import { getProjectIdFromMaterialRow } from './analysisMaterialProjectContext';

export type InventoryMaterialLike = Record<string, unknown>;

/**
 * True when inventory already has a material for this project + Fitter pipeID (details.pipeNo).
 */
export function inventoryHasMaterialForPipeId(
  materials: InventoryMaterialLike[],
  input: { projectId?: string | number | null; pipeID: string }
): boolean {
  const targetProject = String(input.projectId ?? '').trim();
  const targetPipe = String(input.pipeID ?? '').trim().toLowerCase();
  if (!targetProject || !targetPipe) return false;

  return materials.some((row) => {
    const projectId = getProjectIdFromMaterialRow(row);
    if (String(projectId ?? '').trim() !== targetProject) return false;
    const details = row.details as Record<string, unknown> | undefined;
    const pipeNo = String(details?.pipeNo ?? '').trim().toLowerCase();
    return pipeNo === targetPipe;
  });
}
